var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"loader"},[_c('use',{attrs:{"xlink:href":"/images/svg-symbols.svg#loading-model"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }